<template>
  <div class="bjex-main" v-loading="loading">
    <el-page-header @back="goBack"> </el-page-header>
    <div style="margin-bottom: 20px">
      <div v-if="isDetail" style="padding: 20px">
        <el-descriptions :column="1" :labelStyle="{ width: '60px' }">
          <el-descriptions-item label="名称">{{ seeItem.billName }}</el-descriptions-item>
          <el-descriptions-item label="封面"><img style="width: 200px; height: 240px" :src="seeItem.serverHttp + seeItem.imgUrl" /></el-descriptions-item>
          <el-descriptions-item label="适合年级">{{ seeItem.billGradesName }}</el-descriptions-item>
          <el-descriptions-item label="所属专栏">{{ getNameById(seeItem.specialColumn, specialColumnList, 'code', 'name') }}</el-descriptions-item>
          <el-descriptions-item label="简介"><div class="richText" v-html="seeItem.billIntro"></div></el-descriptions-item>
          <el-descriptions-item label="系列图书">
            <div style="width: 98%">
              <el-table :data="seeItem.readBooksList" border stripe highlight-current-row ref="table" :header-cell-style="{ height: '40px', padding: 0 }">
                <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
                <el-table-column label="封面" align="center" width="130">
                  <template slot-scope="scope">
                    <el-image style="width: 100px; height: 100px" :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                      <div slot="error" class="image-err">暂无封面</div></el-image
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
                <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
                <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center" width="85"></el-table-column>
                <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
                <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
                <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
              </el-table>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm" v-else>
        <el-form-item label="名称" prop="billName">
          <el-input v-model="ruleForm.billName" placeholder="请输入书单名称" style="width: 194px"></el-input>
        </el-form-item>
        <el-form-item label="适用年级" prop="billGrades">
          <el-checkbox-group v-model="ruleForm.billGrades">
            <el-checkbox v-for="item in gradelist" :key="item.gradeId" :label="String(item.gradeId)">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="所属专栏" prop="specialColumn">
          <el-radio-group v-model="ruleForm.specialColumn">
            <el-radio v-for="item in specialColumnList" :key="item.code" :label="Number(item.code)">{{ item.name }} </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面" prop="imgUrl">
          <el-upload class="avatar-uploader" :headers="headers" :data="datas" :action="urls" :show-file-list="false" :on-success="handleAvatarSuccess2">
            <img v-if="ruleForm.imgUrl" :src="ruleForm.serverHttp + ruleForm.imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon hjaskg"></i>
          </el-upload>
          <div class="huise" style="width: fit-content">建议尺寸200px*240px，显示效果最佳。支持jpg、jpeg、png，图片大小不超过5M</div>
        </el-form-item>
        <el-form-item label="简介">
          <div style="border: 1px solid #ccc; width: 800px">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor1" :defaultConfig="toolbarConfig" :mode="mode" />
            <Editor style="height: 400px; overflow-y: hidden" v-model="ruleForm.billIntro" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated1" />
          </div>
        </el-form-item>
        <el-form-item label="系列图书" prop="bookIdList">
          <el-button type="primary" @click="addBooks()" size="small">添加</el-button>
          <el-table :data="ruleForm.bookIdList" border stripe style="width: 100%" highlight-current-row ref="table" :header-cell-style="{ height: '40px', padding: 0 }">
            <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
            <el-table-column label="封面" align="center" width="130">
              <template slot-scope="scope">
                <el-image style="width: 100px; height: 100px" :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                  <div slot="error" class="image-err">暂无封面</div></el-image
                >
              </template>
            </el-table-column>
            <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
            <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
            <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center" width="130"></el-table-column>
            <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
            <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
            <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteBook(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="选择图书" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible" :before-close="sjClose">
      <el-form label-width="80px">
        <el-form-item label="书籍来源:">
          <el-button
            type="text"
            @click="
              isSchool = true
              pageNum = 1
              queryBookList()
            "
            :class="isSchool ? '' : 'yanse'"
            >校本书库</el-button
          >
          <el-button
            type="text"
            @click="
              isSchool = false
              pageNum = 1
              queryBookList()
            "
            :class="!isSchool ? '' : 'yanse'"
            >平台书库</el-button
          >
        </el-form-item>
        <el-form-item label="适合年级:">
          <el-button
            type="text"
            @click="
              gradeId = ''
              pageNum = 1
              queryBookList()
            "
            :class="gradeId == '' ? '' : 'yanse'"
            >全部</el-button
          >
          <el-button
            type="text"
            @click="
              gradeId = item.gradeId
              pageNum = 1
              queryBookList()
            "
            :class="item.gradeId == gradeId ? '' : 'yanse'"
            v-for="item in gradelist"
            :key="item.gradeId"
            >{{ item.name }}</el-button
          >
        </el-form-item>
        <el-form-item label="所属专栏:">
          <el-button
            type="text"
            @click="
              specialId = ''
              pageNum = 1
              queryBookList()
            "
            :class="specialId == '' ? '' : 'yanse'"
            >全部</el-button
          >
          <el-button
            type="text"
            @click="
              specialId = item.code
              pageNum = 1
              queryBookList()
            "
            :class="item.code == specialId ? '' : 'yanse'"
            v-for="item in specialColumnList"
            :key="item.code"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 10px">
        <el-cascader
          clearable
          v-model="classifyId"
          @change="
            pageNum = 1
            queryBookList()
          "
          placeholder="请选择图书所属分类"
          :options="options"
          :show-all-levels="false"
          size="small"
        ></el-cascader>
        <el-select
          v-model="bookLevel"
          @change="
            pageNum = 1
            queryBookList()
          "
          placeholder="请选择图书等级"
          clearable
          size="small"
        >
          <el-option v-for="item in bookLevelList" :key="item.id" :label="item.name" :value="item.code"> </el-option>
        </el-select>
        <el-input
          v-model="bookName"
          placeholder="请输入图书名称关键词"
          size="small"
          style="width: 200px"
          @keypress.enter.native="
            pageNum = 1
            queryBookList()
          "
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="
            pageNum = 1
            queryBookList()
          "
          >搜索</el-button
        >
      </div>
      <el-table :data="bookList" border stripe style="width: 100%" highlight-current-row ref="multipleTable" :header-cell-style="{ height: '40px', padding: 0 }" @select="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="封面" align="center" width="130">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
              <div slot="error" class="image-err">暂无封面</div></el-image
            >
          </template>
        </el-table-column>
        <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
        <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
        <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center" width="130"></el-table-column>
        <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
        <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
        <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right; padding: 10px"
        @prev-click="change"
        @next-click="change"
        :page-size="10"
        @current-change="change"
        background
        layout="total,prev, pager, next"
        :hide-on-single-page="true"
        :total="totalCount"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible = false
            sjReset()
          "
          size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitBooks" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { BASE_URL } from '@/api/index'
const editorConfig = {
  // JS 语法
  MENU_CONF: {
    uploadImage: {
      server: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
      customInsert(res, insertFn) {
        // JS 语法
        // res 即服务端的返回结果
        let url = res.data[0].url
        let alt = ''
        let href = res.data[0].url
        // 从 res 中找到 url alt href ，然后插入图片
        insertFn(url, alt, href)
      }
    },
    uploadVideo: {
      server: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
      customInsert(res, insertFn) {
        // JS 语法
        // res 即服务端的返回结果
        let url = res.data[0].url
        let poster = ''
        // 从 res 中找到 url alt href ，然后插入图片
        insertFn(url, poster)
      }
    }
  }

  // 其他属性...
}
var validateList = (rule, value, callback) => {
  if (value.length < 1) {
    callback(new Error('请至少添加一本图书'))
  } else {
    callback()
  }
}
export default {
  data() {
    return {
      isDetail: false,
      editorConfig: editorConfig,
      mode: 'default', // or 'simple'
      toolbarConfig: {
        excludeKeys: ['group-video', 'fullScreen']
      },
      editor1: null,
      loading: false,
      dialogVisible: false,
      gradelist: [],
      specialColumnList: [],
      headers: {
        token: '' //文件上传请求头
      },
      datas: {
        bucketId: 2
      },
      urls: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
      tempBooks: [],
      bookList: [],
      sjForm: {},
      sjrules: {},
      bookName: '',
      rules: {
        // specialColumn: [{ required: true, message: '请选择所属专栏', trigger: 'change' }],
        imgUrl: [{ required: true, message: '请上传书单封面', trigger: 'change' }],
        billGrades: [{ required: true, message: '请选择适用年级', trigger: 'change' }],
        billName: [
          {
            required: true,
            message: '请输入书单名称',
            trigger: 'change'
          }
        ],
        bookIdList: [{ required: true, message: '请添加至少一本图书', validator: validateList }]
      },
      ruleForm: {
        billName: '',
        billGrades: [],
        imgUrl: '',
        serverHttp: '',
        specialColumn: '',
        serverId: '',
        bookIdList: [],
        billIntro: ''
      },
      schoolId: '',
      seeItem: {
        starRuleObj: {},
        readClassifyBookList: []
      },
      classifyId: [],
      bookLevel: '',
      specialId: '',
      gradeId: '',
      bookLevelList: [],
      options: [],
      pageNum: 1,
      totalCount: 0,
      isSchool: true
    }
  },
  created() {
    this.schoolId = JSON.parse(localStorage.getItem('info')).schoolId
    if (this.$route.query.modeType) {
      this.isDetail = true
    }
    this.ruleForm.id = this.$route.query.id || ''
    this.headers.token = localStorage.getItem('token')
    this.queryBookList()
    this.gradegradelist()
    this.dictcode()
    this.dictcode1()
    this.getTreeReadClassify()
    if (this.ruleForm.id != '') {
      this.getBillDetail()
    }
  },
  watch: {},
  methods: {
    change(s) {
      this.pageNum = s
      this.queryBookList()
    },
    getTreeReadClassify() {
      let that = this
      let params = {
        schoolId: -1
      }
      homeApi
        .getTreeReadClassify(params)
        .then((res) => {
          res.data.data = that.xunahj(res.data.data)
          that.options = res.data.data
        })
        .catch(() => {})
    },
    xunahj(s) {
      s.forEach((item) => {
        item.value = item.id
        item.label = item.classifyName
        if (item.chilrenList && item.chilrenList.length > 0) {
          item.children = item.chilrenList
          this.xunahj(item.children)
        }
      })
      return s
    },
    dictcode1() {
      let that = this
      homeApi
        .dictcode({
          code: 'book_level'
        })
        .then((res) => {
          that.bookLevelList = res.data.data
        })
    },
    getNameById(id, targetList, idName, name) {
      let result = '暂无'
      let index = targetList.findIndex((i) => {
        return i[idName] == id
      })
      if (index != -1) {
        result = targetList[index][name]
      }
      return result
    },
    deleteBook(item) {
      let index = this.ruleForm.bookIdList.findIndex((book) => {
        return book.id === item.id
      })
      this.ruleForm.bookIdList.splice(index, 1)
    },
    submitBooks() {
      this.ruleForm.bookIdList = JSON.parse(JSON.stringify(this.tempBooks))
      this.tempBooks = []
      this.dialogVisible = false
    },
    handleSelectionChange(e, row) {
      let index = this.tempBooks.findIndex((fi) => {
        return fi.id == row.id
      })
      if (index != -1) {
        this.tempBooks.splice(index, 1)
      } else {
        this.tempBooks.push(row)
      }
    },
    queryBookList() {
      let that = this
      let params = {
        schoolId: this.isSchool ? this.schoolId : -1,
        bookName: this.bookName,
        pageNum: this.pageNum,
        pageSize: 10,
        publishStatus: 1,
        classifyId: this.classifyId.length > 0 ? this.classifyId[this.classifyId.length - 1].toString() : '',
        specialColumn: this.specialId,
        bookLevel: this.bookLevel,
        bookGrades: this.gradeId
      }
      let tempList = JSON.parse(JSON.stringify(this.tempBooks))
      homeApi
        .queryBookList(params)
        .then((res) => {
          that.bookList = res.data.data.dataList
          that.totalCount = res.data.data.totalCount
          this.$nextTick(() => {
            if (this.$refs.multipleTable) {
              tempList.map((book) => {
                let index = this.bookList.findIndex((item) => {
                  return item.id == book.id
                })
                if (index != -1) {
                  this.$refs.multipleTable.toggleRowSelection(this.bookList[index], true)
                }
              })
            }
          })
        })
        .catch(() => {})
    },
    addBooks() {
      this.dialogVisible = true
      this.tempBooks = JSON.parse(JSON.stringify(this.ruleForm.bookIdList))
      this.$nextTick(() => {
        this.ruleForm.bookIdList.map((book) => {
          let index = this.bookList.findIndex((item) => {
            return item.id == book.id
          })
          if (index != -1) {
            this.$refs.multipleTable.toggleRowSelection(this.bookList[index], true)
          }
        })
      })
    },
    sjReset() {
      this.pageNum = 1
      this.classifyId = []
      this.bookLevel = ''
      this.specialId = ''
      this.gradeId = ''
      this.$refs.multipleTable.clearSelection()
    },
    sjClose(done) {
      this.sjReset()
      done()
    },
    onCreated1(editor) {
      this.editor1 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    handleAvatarSuccess2(res) {
      this.ruleForm.serverHttp = res.data[0].url.replace(res.data[0].fileName, '')
      this.ruleForm.imgUrl = res.data[0].fileName
      this.ruleForm.serverId = res.data[0].bucketId
    },
    goBack() {
      this.$router.go(-1)
    },
    //年级列表
    getGradeStage() {
      let that = this
      homeApi
        .getGradeStage({
          stage: 5
        })
        .then((res) => {
          that.gradelist = res.data.data
        })
    },
    gradegradelist() {
      let params = {
        schoolId: this.schoolId
      }
      homeApi
        .gradegradelist(params)
        .then((res) => {
          this.gradelist = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getNamesByIds(ids, targetList, idName, name) {
      let result = []
      ids.map((id) => {
        let index = targetList.findIndex((i) => {
          return i[idName] == id
        })
        if (index != -1) {
          result.push(targetList[index][name])
        }
      })
      return result
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this
          let params = JSON.parse(JSON.stringify(that.ruleForm))
          // params.schoolId = this.schoolId
          let gradeNames = this.getNamesByIds(params.billGrades, this.gradelist, 'gradeId', 'name')
          params.billGrades = params.billGrades.join(',')
          params.billGradesName = gradeNames.join(',')
          let bookIds = []
          params.bookIdList.map((item) => {
            bookIds.push(item.id)
          })
          params.bookIdList = bookIds
          console.log(params)
          homeApi.saveReadBill(params).then((res) => {
            that.ruleForm.id = res.data.data
            that.$message({
              message: '保存成功',
              type: 'success'
            })
            setTimeout(() => {
              // localStorage.setItem('read_index', 'package')
              this.$router.go(-1)
            }, 1000)
          })
        } else {
          return false
        }
      })
    },
    //课程详情
    getBillDetail() {
      let that = this
      homeApi
        .getBillDetail({
          id: that.ruleForm.id
        })
        .then((res) => {
          if (this.isDetail) {
            that.seeItem = res.data.data
          }
          that.ruleForm = res.data.data
          that.ruleForm.bookIdList = that.ruleForm.readBooksList ? that.ruleForm.readBooksList : []
          that.ruleForm.billGrades = that.ruleForm.billGrades ? that.ruleForm.billGrades.split(',') : []
          console.log(that.ruleForm)
        })
    },
    dictcode() {
      let that = this
      homeApi
        .dictcode({
          code: 'special_column'
        })
        .then((res) => {
          that.specialColumnList = res.data.data
        })
    }
  },
  components: {
    Editor,
    Toolbar
  }
}
</script>

<style lang="less" scoped>
.yanse {
  color: #999;
}
.jxui {
  margin-top: 15px;
  width: 100%;
}
.hjufi {
  border-right: 5px solid #eee;
}
.heiji1 {
  margin-right: 0.5rem;
  line-height: 50px;
  width: 100px;
  height: 50px;
  color: #666;
}
.xu {
  border: 1px #e4e4e4 dashed;
  border-radius: 0.2rem;
}
.cursor {
  cursor: pointer;
}
.lanse {
  color: #409eff;
  margin-left: 10px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 240px;
  line-height: 240px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 240px;
  display: block;
}
.xuanhjifas {
  cursor: pointer;
  margin: 5px 0;
}
.kechns {
  font-size: 18px !important;
  background-color: #409eff;
  color: #fff;
  padding: 8px;
  text-align: center;
  cursor: pointer;
}
.huangse {
  color: #e6a23c;
}
.mat {
  margin-top: 15px;
}
.xuanhjifas {
  padding: 10px 20px;
  cursor: pointer;
}
.xuanhjifas:hover {
  border-color: #b3d8ff;
  color: #409eff;
  background: #ecf5ff;
}
.xuanhjjssss {
  border-color: #b3d8ff;
  color: #fff;
  background: #409eff;
}
.dasgasdg {
  font-size: 16px !important;
  cursor: pointer;
  margin-top: 5px;
}
.rit {
  text-align: right;
}
a {
  text-decoration: none;
  color: #409eff;
}
a:hover,
a:visited,
a:link,
a:active {
  color: #409eff;
  // 设置使所有a标签的四种状态都和本身颜色保持一致，样式代码自己写
}
.spb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.stForm /deep/ .el-form-item {
  margin-bottom: 10px;
}
.questionItem {
  margin-bottom: 10px;
  font-weight: 600;
}
.mr-10 {
  margin-right: 10px;
}
.richText /deep/ img {
  max-width: 100% !important;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.youcedigao /deep/ .el-dialog {
  margin: 0 40px 50px 0;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/read/newBill.vue